"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGULAR_ID = exports.PASSPORT = void 0;
exports.PASSPORT = 'P';
exports.REGULAR_ID = 'N';
//# sourceMappingURL=identificationTypes.js.map